import { render, staticRenderFns } from "./UpExercise.vue?vue&type=template&id=7d364855&scoped=true&"
import script from "./UpExercise.vue?vue&type=script&lang=js&"
export * from "./UpExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d364855",
  null
  
)

export default component.exports